export const VOLUME_DECIMAL_PLACE_PRECISION = 10;
